import React, { useState, useEffect } from 'react'

import s from './Carousel.module.css'

type Props = {
  items: any[]
  children: (carouselParams: {
    onPreviousClick: () => void
    onNextClick: () => void
  }) => React.ReactElement
}

const Carousel = ({ items = [], children }: Props) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  let interval

  useEffect(() => {
    interval = setInterval(() => {
      onNextClick()
    }, 3500)

    return () => {
      clearInterval(interval)
    }
  }, [currentIndex])

  const onNextClick = () => {
    setCurrentIndex((prevIndex) =>
      Math.abs(prevIndex - 1) === items.length ? 0 : prevIndex - 1
    )
  }

  const onPreviousClick = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex + 1 > 0 ? -(items.length - 1) : prevIndex + 1
    )
  }

  return (
    <div className={s.carouselWrapper}>
      <div className={s.carousel}>
        {items.map((item, index) => (
          <img
            key={index}
            src={item}
            className={s.image}
            style={{
              transform: `translateX(${(index + currentIndex) * 100}%)`
            }}
          />
        ))}
      </div>

      {children({ onPreviousClick, onNextClick })}
    </div>
  )
}

export default Carousel
